/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![StickerWink1Icon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABfElEQVR4nN2VvUoDQRCAU9molVraGrETbLQJCgHB25lJZDNzoIW+hBiLs9SHEMVCIQiJb5KnsIqiViJqZC93nOR+sneHhS5Ms/PzzezM7lYq/2oh8iIQ3ymSVyAZ5pGRD3cBdDU1uEJ5zBsYYsJPJlYMYDIvH1xGgtKJAYocC6RX8ZJQQWSAyBtO010GkmuF8lEEkglwyF0P94l4SRHfZzT3uF7fm1bIbWsAkLxBQ3ZCneO482kArfWM7w8wawVQyJ8AsmZdAXLbQID4JAdAr/xqDyCCXQDIKqD0E0axb3S+TVEAkHhGt631AiBfKZRnI0ByafoS+HllKnhXxM2Ycdh8dHeNTYLfwLaCIZB8AfINQGuTaH/OiGrIlkK5DY6q55BbM6OalsgkwDBjgo4yg5YCoPSMn9Z6CojPFfLDD/1haYBDbi3wOxur6jSxgryPnQ5u8FjmXsYRcbfIRQKb4L4h6Kr5LAoCPPsvE6Vj3vMJ0zOIEmsdWAX/s+sbyQF9px2hETYAAAAASUVORK5CYII=)
 */
export const StickerWink1Icon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M6 2h12a4 4 0 0 1 4 4v7.5a.5.5 0 0 1-.5.5H19a5 5 0 0 0-5 5v2.5a.5.5 0 0 1-.5.5H6a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4Zm11.5 8a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM5.1 6.55a1 1 0 0 1 1.35-.44l3 1.5a1 1 0 0 1 0 1.78l-3 1.5a1 1 0 1 1-.9-1.78l1.21-.61-1.2-.6a1 1 0 0 1-.45-1.35Zm3.99 4.9a1 1 0 0 0-1.66 1.1 5.5 5.5 0 0 0 9.14 0 1 1 0 0 0-1.66-1.1 3.5 3.5 0 0 1-5.82 0Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M21.66 16c.03 0 .05.03.04.06a3 3 0 0 1-.58.82l-4.24 4.24a3 3 0 0 1-.82.58.04.04 0 0 1-.06-.04V19a3 3 0 0 1 3-3h2.66Z"
        className={colorClass}
      />
    </svg>
  );
};
